import { AppProvider as ShopifyAppProvider } from '@shopify/polaris'
import Link from '@Shared/components/Link'
import { BrowserRouter } from 'react-router'
import { Provider as ReduxProvider } from 'react-redux'
import store from '@Store/store'
import en from '@Lang/locales/en'
import IntercomProvider from '@Utils/IntercomProvider'

function AppProvider({ children }: { children: JSX.Element[] }): JSX.Element {
  return (
    <ReduxProvider store={store}>
      <BrowserRouter>
        <IntercomProvider>
          <ShopifyAppProvider i18n={en} linkComponent={Link}>
            {children}
          </ShopifyAppProvider>
        </IntercomProvider>
      </BrowserRouter>
    </ReduxProvider>
  )
}

export default AppProvider
